import styled from 'styled-components'
import Colors from 'builder/styles/colors'

export const Hint = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  color: ${Colors.Neutral50};
`
